export const mediaPositions = {
  LEFT: 'left',
  RIGHT: 'right',
};
